var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionEditTrack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8 7.65685 6.65685 9 5 9C3.34315 9 2 7.65685 2 6C2 4.34315 3.34315 3 5 3C6.65685 3 8 4.34315 8 6ZM6 6C6 6.55228 5.55228 7 5 7C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.55228 5 6 5.44772 6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8341 6.9863C7.94159 6.6774 8 6.34552 8 6C8 5.65448 7.94159 5.3226 7.8341 5.0137C7.88806 5.00469 7.94348 5 8 5H13C15.2091 5 17 6.79086 17 9C17 11.2091 15.2091 13 13 13H6.5C5.11929 13 4 14.1193 4 15.5C4 16.8807 5.11929 18 6.5 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H6.5C4.01472 20 2 17.9853 2 15.5C2 13.0147 4.01472 11 6.5 11H13C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7H8C7.94348 7 7.88806 6.99531 7.8341 6.9863Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 10.7071L17.2929 7.70708L8 17V20H11L20.2929 10.7071Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 6.29286L20.2929 4.70708C20.6834 4.31655 21.3166 4.31655 21.7071 4.70708L23.2929 6.29286C23.6834 6.68339 23.6834 7.31655 23.2929 7.70708L21.7071 9.29286L18.7071 6.29286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionEditTrack);
export default __webpack_public_path__ + "static/media/ic_action_edit_track.d4e157c7f8057d3cb580873f9021f8b7.svg";
export { ForwardRef as ReactComponent };